// Generated by CoffeeScript 2.7.0
var Helpers;

import App from './app.js';

import Utilities from './utilities.js';

import {
  getZH_CN,
  translate,
  t
} from './i18n.js';

import UrlHelper from './url_helper.js';

import FileHelper from './file_helper.js';

export default Helpers = {
  App: App,
  Utilities: Utilities,
  UrlHelper: UrlHelper,
  FileHelper: FileHelper,
  getZH_CN: getZH_CN,
  translate: translate,
  t: t
};
